import { render, staticRenderFns } from "./FooterMobile.vue?vue&type=template&id=7fcf8fcd&scoped=true"
import script from "./FooterMobile.vue?vue&type=script&lang=js"
export * from "./FooterMobile.vue?vue&type=script&lang=js"
import style0 from "./FooterMobile.vue?vue&type=style&index=0&id=7fcf8fcd&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcf8fcd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fcf8fcd')) {
      api.createRecord('7fcf8fcd', component.options)
    } else {
      api.reload('7fcf8fcd', component.options)
    }
    module.hot.accept("./FooterMobile.vue?vue&type=template&id=7fcf8fcd&scoped=true", function () {
      api.rerender('7fcf8fcd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FooterMobile.vue"
export default component.exports